import "./index.scss";

import { Bar, HorizontalBar, Pie, defaults } from "react-chartjs-2";
import React, { Component } from "react";
import { getBarData, getPieData } from "../../actions/dataActions";

import Loading from "../Loading";
import PropTypes from "prop-types";
import Title from "../Title";
import { changeMenu } from "../../actions/themeActions";
import { connect } from "react-redux";

class index extends Component {
  componentDidMount() {
    this.props.changeMenu(this.props.location.pathname.slice(1));
    this.props.getBarData();
    this.props.getPieData();
  }

  render() {
    const {
      pieData,
      barData,
      theme,
      showMenu,
      loadingPieData,
      loadingBarData
    } = this.props;

    const labelsPieArr = [];
    const dataPieArr = [];

    const labelsBarArr = [];
    const dataBarArr = [];
    const dataBarTotalArr = [];

    defaults.global.defaultFontColor =
      theme === "dark" ? "rgb(173, 202, 222)" : "rgb(69, 97, 115)";

    // eslint-disable-next-line array-callback-return
    pieData.map(row => {
      labelsPieArr.push(row.id);
      dataPieArr.push(row.valor);
    });

    // eslint-disable-next-line array-callback-return
    barData.map(row => {
      labelsBarArr.push(row.nomeUnidade);
      dataBarArr.push(row.qtdeChamadosConcluidos);
      dataBarTotalArr.push(row.totalDeChamados);
    });

    const dataPieChart = {
      labels: labelsPieArr,
      datasets: [
        {
          data: dataPieArr,
          borderWidth: 0,
          backgroundColor: [
            "#394a6d",
            "#c0ffb3",
            "#23374d",
            "#3c9d9b",
            "#52de97",
            "#1089ff",
            "#e5e5e5",
            "#504658",
            "#ce2e6c",
            "#ffb5b5"
          ]
        }
      ]
    };

    const dataBarChart = {
      labels: labelsBarArr,
      datasets: [
        {
          label: "Quantidade de chamados concluídos",
          backgroundColor: "#7dee89",
          data: dataBarArr
        },
        {
          label: "Total de chamados",
          backgroundColor: theme === "dark" ? "#2D4961" : "#456173",
          data: dataBarTotalArr
        }
      ]
    };

    const optionsPie = {
      legend: {
        position: window.innerWidth > 480 ? "right" : "bottom"
      }
    };

    const optionsBar = {
      legend: {
        position: "bottom"
      }
    };

    return (
      <div id="ProjectsIndicators" className={showMenu ? `blur` : ""}>
        <Title
          text={`Indicadores de projetos`}
          type={`SECTION`}
          theme={theme}
        />
        {loadingPieData || loadingBarData ? (
          <Loading />
        ) : (
          <div className="charts">
            <div className="pie-container">
              <h3>Gráfico de todos os chamados por situação</h3>
              <Pie
                data={dataPieChart}
                options={optionsPie}
                height={window.innerWidth > 480 ? null : 200}
              ></Pie>
            </div>
            <br />
            <div className="bar-container">
              <h3>
                Chamados das unidades de ensino e das unidades da adm. superior
              </h3>
              {window.innerWidth > 480 ? (
                <Bar data={dataBarChart} options={optionsBar}></Bar>
              ) : (
                <HorizontalBar
                  data={dataBarChart}
                  options={optionsBar}
                  height={window.innerWidth > 480 ? null : 350}
                ></HorizontalBar>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

index.propTypes = {
  getPieData: PropTypes.func.isRequired,
  getBarData: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
  loadingPieData: PropTypes.bool.isRequired,
  loadingBarData: PropTypes.bool.isRequired,
  showMenu: PropTypes.bool.isRequired,
  changeMenu: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  theme: state.theme.theme,
  pieData: state.data.pieData,
  barData: state.data.barData,
  loadingPieData: state.data.loadingPieData,
  loadingBarData: state.data.loadingBarData,
  showMenu: state.theme.showMenu
});

export default connect(
  mapStateToProps,
  { changeMenu, getPieData, getBarData }
)(index);
